var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"core"}}),_c('van-dialog',{attrs:{"title":"作品名称"},on:{"confirm":_vm.save},model:{value:(_vm.nameTip),callback:function ($$v) {_vm.nameTip=$$v},expression:"nameTip"}},[_c('van-field',{attrs:{"label":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }